import { proxy } from '@/utils'

import render from './render'

export default function(options) {
  return {
    name: 'RulesType',

    mixins: [ proxy({ type: options.type }) ],

    props: {
      disabled: Boolean,
      readonly: Boolean
    },

    render(h) {
      return render.call(this, h, options)
    }
  }
}
